import type { RoadMapItemCategory } from '@zafire/components';
import type { ReactNode } from 'react';
import type { EventType } from '../../api/generated/client';

export const getLifeSVGEventIcon = (topicKey: string): ReactNode => {
    const iconSize = { width: 24, height: 24 };
    const lifeEventSVGIconMap: Record<string, ReactNode> = {
        FAMILY: (
            <svg {...iconSize}>
                <path
                    d="M16 4C16 2.89 16.89 2 18 2C19.11 2 20 2.89 20 4C20 5.11 19.11 6 18 6C16.89 6 16 5.11 16 4ZM20 22V16H22.5L19.96 8.37C19.68 7.55 18.92 7 18.06 7H17.94C17.08 7 16.31 7.55 16.04 8.37L15.18 10.95C16.26 11.55 17 12.68 17 14V22H20ZM12.5 11.5C13.33 11.5 14 10.83 14 10C14 9.17 13.33 8.5 12.5 8.5C11.67 8.5 11 9.17 11 10C11 10.83 11.67 11.5 12.5 11.5ZM5.5 6C6.61 6 7.5 5.11 7.5 4C7.5 2.89 6.61 2 5.5 2C4.39 2 3.5 2.89 3.5 4C3.5 5.11 4.39 6 5.5 6ZM7.5 22V15H9V9C9 7.9 8.1 7 7 7H4C2.9 7 2 7.9 2 9V15H3.5V22H7.5ZM14 22V18H15V14C15 13.18 14.32 12.5 13.5 12.5H11.5C10.68 12.5 10 13.18 10 14V18H11V22H14Z"
                    fill="currentColor"
                />
            </svg>
        ),
        PASSION: (
            <svg {...iconSize}>
                <path
                    d="M7 14.0005C5.34 14.0005 4 15.3405 4 17.0005C4 18.3105 2.84 19.0005 2 19.0005C2.92 20.2205 4.49 21.0005 6 21.0005C8.21 21.0005 10 19.2105 10 17.0005C10 15.3405 8.66 14.0005 7 14.0005ZM20.71 4.63055L19.37 3.29055C18.98 2.90055 18.35 2.90055 17.96 3.29055L9 12.2505L11.75 15.0005L20.71 6.04055C21.1 5.65055 21.1 5.02055 20.71 4.63055Z"
                    fill="currentColor"
                />
            </svg>
        ),
        SUCCESSION: (
            <svg {...iconSize}>
                <path
                    d="M10.2698 6H13.7298C14.6598 6 15.3598 5.17 15.2098 4.25L14.9098 2.46C14.6698 1.04 13.4398 0 11.9998 0C10.5598 0 9.32983 1.04 9.08983 2.47L8.78983 4.26C8.63983 5.17 9.33983 6 10.2698 6Z"
                    fill="currentColor"
                />
                <path
                    d="M1.65953 5.11C1.52953 5.37 1.47953 5.68 1.55953 5.99C1.71953 6.68 2.31953 7.02 3.08953 6.99C3.08953 6.99 4.57953 6.99 5.03953 6.99C5.86953 6.99 6.54954 6.41 6.54954 5.7C6.54954 5.56 6.51954 5.43 6.47954 5.3C6.46953 5.27 6.46953 5.25 6.48953 5.22C6.57954 5.06 6.62954 4.88 6.62954 4.69C6.62954 4.38 6.48953 4.09 6.26954 3.87C6.23953 3.84 6.23953 3.81 6.24954 3.77C6.31954 3.57 6.31954 3.34 6.25954 3.12C6.09954 2.69 5.70953 2.4 5.26953 2.38C5.23953 2.38 5.21953 2.37 5.19953 2.35C5.02953 2.14 4.71953 2 4.36953 2C4.06953 2 3.79953 2.1 3.61953 2.26C3.58953 2.29 3.55953 2.29 3.52953 2.28C3.38953 2.22 3.22953 2.19 3.06953 2.19C2.41953 2.19 1.88953 2.68 1.82953 3.31C1.82953 3.33 1.81953 3.35 1.79953 3.37C1.50953 3.63 1.33953 4.02 1.38953 4.42C1.41953 4.64 1.50953 4.85 1.63953 5.02C1.66953 5.04 1.66953 5.08 1.65953 5.11Z"
                    fill="currentColor"
                />
                <path
                    d="M16.24 7.65C15.07 7.13 13.63 6.75 12 6.75C10.37 6.75 8.93 7.14 7.76 7.65C6.68 8.13 6 9.21 6 10.39V12H18V10.39C18 9.21 17.32 8.13 16.24 7.65Z"
                    fill="currentColor"
                />
                <path
                    d="M1.22 8.58C0.48 8.9 0 9.62 0 10.43V12H4.5V10.39C4.5 9.56 4.73 8.78 5.13 8.1C4.76 8.04 4.39 8 4 8C3.01 8 2.07 8.21 1.22 8.58Z"
                    fill="currentColor"
                />
                <path
                    d="M22.7791 8.58C21.9291 8.21 20.9891 8 19.9991 8C19.6091 8 19.2391 8.04 18.8691 8.1C19.2691 8.78 19.4991 9.56 19.4991 10.39V12H23.9991V10.43C23.9991 9.62 23.5191 8.9 22.7791 8.58Z"
                    fill="currentColor"
                />
                <path
                    d="M21.9999 5V4.5C21.9999 3.4 21.0999 2.5 19.9999 2.5H17.9999C17.5799 2.5 17.3499 2.98 17.6099 3.31L18.3099 3.94C18.1199 4.25 17.9999 4.61 17.9999 5C17.9999 6.1 18.8999 7 19.9999 7C21.0999 7 21.9999 6.1 21.9999 5Z"
                    fill="currentColor"
                />
            </svg>
        ),
        RETIREMENT: (
            <svg {...iconSize}>
                <path
                    d="M7.5 4.5C8.6 4.5 9.5 3.6 9.5 2.5C9.5 1.4 8.6 0.5 7.5 0.5C6.4 0.5 5.5 1.4 5.5 2.5C5.5 3.6 6.4 4.5 7.5 4.5ZM3.75 7.9L1 22H3.1L4.85 14L7 16V22H9V14.45L6.95 12.4L7.55 9.4C8.85 11 10.8 12 13 12V10C11.15 10 9.55 9 8.65 7.55L7.7 5.95C7.35 5.35 6.7 5 6 5C5.75 5 5.5 5.05 5.25 5.15L0 7.3V12H2V8.65L3.75 7.9ZM11 1V8H14.75V22H16.25V8H20V1H11ZM16.01 7V5.25H12.5V3.75H16.01V2L18.5 4.5L16.01 7Z"
                    fill="currentColor"
                />
            </svg>
        ),
        REAL_ESTATE: (
            <svg {...iconSize}>
                <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" fill="currentColor" />
            </svg>
        ),
        WEALTH: (
            <svg {...iconSize}>
                <path
                    d="M5.80031 7.9C3.53031 7.31 2.80031 6.7 2.80031 5.75C2.80031 4.66 3.81031 3.9 5.50031 3.9C7.28031 3.9 7.94031 4.75 8.00031 6H10.2103C10.1403 4.28 9.09031 2.7 7.00031 2.19V0H4.00031V2.16C2.06031 2.58 0.500312 3.84 0.500312 5.77C0.500312 8.08 2.41031 9.23 5.20031 9.9C7.70031 10.5 8.20031 11.38 8.20031 12.31C8.20031 13 7.71031 14.1 5.50031 14.1C3.44031 14.1 2.63031 13.18 2.52031 12H0.320312C0.440312 14.19 2.08031 15.42 4.00031 15.83V18H7.00031V15.85C8.95031 15.48 10.5003 14.35 10.5003 12.3C10.5003 9.46 8.07031 8.49 5.80031 7.9Z"
                    fill="currentColor"
                />
            </svg>
        ),
        BUSINESS: (
            <svg {...iconSize}>
                <path
                    d="M8 13V12H1.01L1 16C1 17.11 1.89 18 3 18H17C18.11 18 19 17.11 19 16V12H12V13H8ZM18 4H13.99V2L11.99 0H7.99L5.99 2V4H2C0.9 4 0 4.9 0 6V9C0 10.11 0.89 11 2 11H8V9H12V11H18C19.1 11 20 10.1 20 9V6C20 4.9 19.1 4 18 4ZM12 4H8V2H12V4Z"
                    fill="currentColor"
                />
            </svg>
        ),
        MATURITY: (
            <svg {...iconSize}>
                <path
                    d="M3,15.4c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.3-0.4-0.6-0.4-0.9V6.5h1.1v7.6c0,0.1,0,0.1,0.1,0.2
		C2.9,14.3,3,14.3,3,14.3h12.8v1.1H3z M5.6,12.8c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.3-0.4-0.6-0.4-0.9V5.9c0-0.4,0.1-0.7,0.4-0.9
		c0.3-0.3,0.6-0.4,0.9-0.4H17c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9v5.6c0,0.4-0.1,0.7-0.4,0.9c-0.3,0.3-0.6,0.4-0.9,0.4
		H5.6z M6.7,11.8c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4v1.1c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1H6.7z M15.9,11.8
		H17c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-1.1c-0.4,0-0.7,0.1-1,0.4C16,11.1,15.9,11.4,15.9,11.8z M11.3,10.8
		c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6
		C9.4,7.6,9.2,8.1,9.2,8.7c0,0.6,0.2,1.1,0.6,1.5C10.2,10.6,10.7,10.8,11.3,10.8z M5.4,6.9c0.4,0,0.7-0.1,0.9-0.4
		C6.6,6.3,6.7,6,6.7,5.6H5.6c-0.1,0-0.1,0-0.2,0.1C5.4,5.7,5.4,5.8,5.4,5.9V6.9z M17.2,6.9V5.9c0-0.1,0-0.1-0.1-0.2
		C17.1,5.6,17,5.6,17,5.6h-1.1c0,0.4,0.1,0.7,0.4,1C16.5,6.8,16.8,6.9,17.2,6.9z"
                    fill="currentColor"
                />
            </svg>
        ),
    };

    return lifeEventSVGIconMap[topicKey];
};

export const getRoadmapEventIcon = (topicKey?: string, eventType?: EventType): RoadMapItemCategory => {
    if (eventType === 'MATURITY' && topicKey === 'WEALTH') {
        return getIconByTopicKey('MATURITY');
    }

    return getIconByTopicKey(topicKey);
};

const getIconByTopicKey = (topicKey?: string): RoadMapItemCategory => {
    const iconByTopicKeyMap: Record<string, RoadMapItemCategory> = {
        FAMILY: 'family',
        PASSION: 'passions',
        SUCCESSION: 'succession',
        RETIREMENT: 'retirement',
        REAL_ESTATE: 'real-estate',
        WEALTH: 'wealth',
        BUSINESS: 'business',
        MATURITY: 'maturity',
    };

    return topicKey ? iconByTopicKeyMap[topicKey] : '';
};

export const getZfLifeEventIconForTile = (topicKey?: string) => {
    const zfLifeEventIconForTileMap: Record<string, string> = {
        FAMILY: 'family_restroom',
        PASSION: 'brush',
        SUCCESSION: 'escalator_warning',
        RETIREMENT: 'follow_the_signs',
        REAL_ESTATE: 'home',
        WEALTH: 'attach_money',
        BUSINESS: 'business_center',
        MATURITY: 'universal_currency_alt',
    };

    return topicKey ? zfLifeEventIconForTileMap[topicKey] : '';
};
